import type { BillingRow, InvoiceRow } from "./paymentsTypes";

function isoDaysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export const SEED_INVOICES: InvoiceRow[] = [
  {
    id: "inv-1",
    number: "INV-2026-0042",
    customerName: "Jane Cooper",
    amount: 128.5,
    currency: "GBP",
    status: "paid",
    issuedAt: isoDaysAgo(2),
    dueAt: isoDaysAgo(0),
  },
  {
    id: "inv-2",
    number: "INV-2026-0041",
    customerName: "Alex Morgan",
    amount: 64.0,
    currency: "GBP",
    status: "open",
    issuedAt: isoDaysAgo(5),
    dueAt: isoDaysAgo(25),
  },
  {
    id: "inv-3",
    number: "INV-2026-0040",
    customerName: "Studio North Ltd",
    amount: 890.0,
    currency: "GBP",
    status: "draft",
    issuedAt: isoDaysAgo(7),
    dueAt: isoDaysAgo(37),
  },
  {
    id: "inv-4",
    number: "INV-2026-0039",
    customerName: "Priya Shah",
    amount: 42.25,
    currency: "GBP",
    status: "paid",
    issuedAt: isoDaysAgo(12),
    dueAt: isoDaysAgo(10),
  },
  {
    id: "inv-5",
    number: "INV-2026-0038",
    customerName: "Chris Lee",
    amount: 210.0,
    currency: "GBP",
    status: "void",
    issuedAt: isoDaysAgo(20),
    dueAt: isoDaysAgo(18),
  },
  {
    id: "inv-6",
    number: "INV-2026-0037",
    customerName: "Bloom Hair Co.",
    amount: 1560.75,
    currency: "GBP",
    status: "open",
    issuedAt: isoDaysAgo(21),
    dueAt: isoDaysAgo(14),
  },
  {
    id: "inv-7",
    number: "INV-2026-0036",
    customerName: "Sam Rivera",
    amount: 33.99,
    currency: "GBP",
    status: "paid",
    issuedAt: isoDaysAgo(28),
    dueAt: isoDaysAgo(26),
  },
  {
    id: "inv-8",
    number: "INV-2026-0035",
    customerName: "The Loft Spa",
    amount: 445.0,
    currency: "GBP",
    status: "open",
    issuedAt: isoDaysAgo(30),
    dueAt: isoDaysAgo(15),
  },
  {
    id: "inv-9",
    number: "INV-2026-0034",
    customerName: "Taylor Brooks",
    amount: 78.0,
    currency: "GBP",
    status: "draft",
    issuedAt: isoDaysAgo(31),
    dueAt: isoDaysAgo(61),
  },
  {
    id: "inv-10",
    number: "INV-2026-0033",
    customerName: "Urban Cuts",
    amount: 312.4,
    currency: "GBP",
    status: "paid",
    issuedAt: isoDaysAgo(35),
    dueAt: isoDaysAgo(33),
  },
];

export const SEED_BILLING: BillingRow[] = [
  {
    id: "bill-1",
    reference: "PAYOUT-2026-03",
    periodLabel: "Mar 2026",
    amount: 4820.12,
    currency: "GBP",
    status: "Paid out",
    processedAt: isoDaysAgo(3),
  },
  {
    id: "bill-2",
    reference: "FEE-2026-03",
    periodLabel: "Mar 2026 — platform fees",
    amount: 124.6,
    currency: "GBP",
    status: "Settled",
    processedAt: isoDaysAgo(4),
  },
  {
    id: "bill-3",
    reference: "PAYOUT-2026-02",
    periodLabel: "Feb 2026",
    amount: 3910.0,
    currency: "GBP",
    status: "Paid out",
    processedAt: isoDaysAgo(34),
  },
  {
    id: "bill-4",
    reference: "ADJ-2026-01",
    periodLabel: "Jan 2026 — adjustment",
    amount: -22.5,
    currency: "GBP",
    status: "Posted",
    processedAt: isoDaysAgo(60),
  },
  {
    id: "bill-5",
    reference: "PAYOUT-2026-01",
    periodLabel: "Jan 2026",
    amount: 4102.88,
    currency: "GBP",
    status: "Paid out",
    processedAt: isoDaysAgo(62),
  },
  {
    id: "bill-6",
    reference: "FEE-2026-02",
    periodLabel: "Feb 2026 — platform fees",
    amount: 118.2,
    currency: "GBP",
    status: "Settled",
    processedAt: isoDaysAgo(36),
  },
];
